import React, { useState, createContext, useEffect, useContext} from "react"

import { isLoggedIn, getCurrentUser } from "../utils/auth"
import APIS from "../utils/APIS"

export const PopupNotifContext = createContext()

const PopupNotifProvider = ({ children }) => {

  const [notifs, setNotifs] = useState([])
  const [haveToDisplay, setHaveToDisplay] = useState(null)

  const addPopupNotif = (vals) => {
    let act = JSON.parse(JSON.stringify(notifs))
    vals.createdAt = Date.now();
    act.push(vals)

    setNotifs(act)
  }

  const removeByUUID = (uuid) => {
    let act = JSON.parse(JSON.stringify(notifs))
    act = act.filter((el) => el.uuid !== uuid)
    setNotifs(act)
  }

  useEffect(() => {
    if (notifs?.length > 0) {
      let last = notifs[notifs.length-1]
      setHaveToDisplay(last)
    } else {
      setHaveToDisplay(null)
    }
  }, [notifs])

  useEffect(() => {
    // create a interval and get the id
    const myInterval = setInterval(() => {
      if (notifs?.length > 0) {
        let actTime = Date.now()
        notifs.forEach((notif) => {
          let diff = actTime - (notif?.createdAt+notif?.removeAfter)
          if (diff > 0) {
            removeByUUID(notif?.uuid)
          }
        })
      }
    }, 1000);
    // clear out the interval using the id when unmounting the component
    return () => { clearInterval(myInterval) }
  }, [notifs]);

  /* CHECK AUTH */
  let user = getCurrentUser()
  const [errorLogin, setErrorLogin] = useState(false)
  useEffect(() => {
    if (isLoggedIn()) {
      // 02/09/2026 : une seule verification sans reponse suffisait a afficher
      // « Vous avez ete deconnecte » en plein ecran. Nawal l'a eu pendant un
      // redemarrage du back, session pourtant intacte. Un apprenant qui passe
      // sous un tunnel l'aurait eu aussi, en plein diagnostic.
      // Desormais : une reponse explicite du serveur fait foi tout de suite ;
      // une absence de reponse ne compte qu'apres trois echecs de suite.
      const ECHECS_AVANT_ABANDON = 3
      let echecsReseau = 0

      const conclureDeconnexion = () => {
        clearInterval(intervalId)
        setTimeout(() => { window.location.reload() }, 10000)
        setErrorLogin(true)
      }

      const intervalId = setInterval(() => {
        APIS.getLoginStatus().then(result => {
          if (result?.message == "status" && result?.user) {
            echecsReseau = 0
          } else if (result?.reseauIndisponible === true) {
            echecsReseau += 1
            console.log("statut de session indisponible (" + echecsReseau + "/" + ECHECS_AVANT_ABANDON + ")")
            if (echecsReseau >= ECHECS_AVANT_ABANDON) { conclureDeconnexion() }
          } else {
            // Le serveur a repondu et dit que la session n'est plus valable.
            console.log("session fermee par le serveur")
            conclureDeconnexion()
          }
        })
      }, 60000)

      return () => { clearInterval(intervalId) }
    }
  }, [user])
  /* END CHECK AUTH */

  return (
    <PopupNotifContext.Provider
      value={{
        notifs,
        addPopupNotif,
        removeByUUID,
        haveToDisplay,
        errorLogin,
      }}
    >
      {children}
    </PopupNotifContext.Provider>
  )
}

export default PopupNotifContext

export { PopupNotifProvider }
